module.exports = __webpack_public_path__ + "static/media/messenger.46535ad0.svg";